const BASE_URL =
    (process.env.REACT_APP_API_ROOT_LMS || process.env.REACT_APP_API_ROOT_DEFAULT) + '/lms/';

export const urls = {
    ledgers_report: BASE_URL + 'ledgers/reports/',
    upcoming_dues_report: BASE_URL + 'loans/upcoming_dues/',
    debtors_report: BASE_URL + 'debtors_reports/',

    accounts: BASE_URL + 'accounts/',
    account_details: BASE_URL + 'accounts/:id/',
    account_summary: BASE_URL + 'accounts/:id/summary/',
    account_soa: BASE_URL + 'accounts/:id/soa/',
    account_interest_certificate: BASE_URL + 'accounts/:id/interest_certificate/',
    account_disbursement_advice: BASE_URL + 'accounts/:id/disbursement_advice/',
    account_write_off: BASE_URL + 'accounts/:id/writeoff',

    loans: BASE_URL + 'loans/',
    loan_details: BASE_URL + 'loans/:id',
    loan_summary: BASE_URL + 'loans/:id/summary/',
    loan_create_disbursement: BASE_URL + 'loans/create_disbursement',
    loans_mark_running: BASE_URL + 'loans/:id/mark_running',
    loans_mark_closed: BASE_URL + 'loans/:id/mark_closed',
    loans_revert: BASE_URL + 'loans/:id/revert',
    loans_excess_balance: BASE_URL + 'loans/excess_balance',
    loans_refunds: BASE_URL + 'loans/:loan_id/refunds',
    loans_adjustments: BASE_URL + 'loans/:loan_id/adjustments',

    line_details: BASE_URL + 'line_details/:id/',
    refresh_line_details: BASE_URL + 'accounts/:id/update_line_detail/',
    loan_data: BASE_URL + 'loan_data/:id',

    records: BASE_URL + 'records/',
    records_unmatched: BASE_URL + 'records/unmatched/',
    records_mark_processed: BASE_URL + 'records/:id/mark_processed',
    records_revert: BASE_URL + 'records/:id/revert',
    records_refunds: BASE_URL + 'records/:id/refunds',
    records_adjustments: BASE_URL + 'records/:id/adjustments',
    records_bulk_create: BASE_URL + 'records/bulk_create',
    records_approval: BASE_URL + 'records/:id/request_approval/',
    records_download_excel: BASE_URL + 'records/download_excel/',

    create_fee: BASE_URL + 'fees/',
    fee_settlements: BASE_URL + 'fees/:id/demands/',

    ledger: BASE_URL + 'ledgers/',
    ledger_download_excel: BASE_URL + 'ledgers/download_excel/',
    ledger_run_account_summary: BASE_URL + 'ledgers/run_account_summary/',

    tasks: BASE_URL + 'tasks/',
    task_details: BASE_URL + 'tasks/:id/',

    reports_roi_computation: BASE_URL + 'reports/roi_computation/',
    reports_customer_portfolio: BASE_URL + 'reports/customer_portfolio/',
    reports_excess_balance: BASE_URL + 'reports/excess_balance/',
    reports_repayment_advice: BASE_URL + 'reports/repayment_advice/',
    reports_debtor_report: BASE_URL + 'reports/debtor/',
    reports_partner_payout: BASE_URL + 'reports/partner_payout/',
    reports_nach_loc_mis: BASE_URL + 'reports/nach_loc_mis/',
    reports_month_end_report: BASE_URL + 'reports/month_end/',
    reports_merge_report: BASE_URL + 'reports/merge/',
    reports_ALM_SCF_report: BASE_URL + 'reports/alm_scf/',
    reports_ANR_report: BASE_URL + 'reports/anr/',
    reports_repayment_breakdown_report: BASE_URL + 'reports/repayment_breakdown/',
    reports_repayment_schedule_report: BASE_URL + 'reports/repayment_schedule/',
    reports_overpay_report: BASE_URL + 'reports/overpay/',
    reports_daily_pos: BASE_URL + 'reports/daily_pos/',
    reports_daily_transaction: BASE_URL + 'reports/daily_transaction/',
    reports_portfolio_application_level: BASE_URL + 'reports/portfolio_application/',
    reports_portfolio_loan_level: BASE_URL + 'reports/portfolio_loan/',
    reports_loan_closure: BASE_URL + 'reports/loan_closure/',
    reports_loan_tagging: BASE_URL + 'reports/loan_tagging/',
    monthly_due_report: BASE_URL + 'reports/monthly_due/',
    aum_query_report: BASE_URL + 'reports/aum_query/',
    accrued_but_not_due_report: BASE_URL + 'reports/accrued_due/',
    due_report: BASE_URL + 'reports/due_report/',
    month_end_pos_report: BASE_URL + 'reports/month_end_pos_report/',

    outstanding_report: BASE_URL + 'reports/outstanding_report/',
    repayment_report: BASE_URL + 'reports/repayment_report/',
    payout_report: BASE_URL + 'reports/payout_report/',
    customer_portfolio_report_tl: BASE_URL + 'reports/customer_portfolio_report_tl/',
    fee_and_charges_report: BASE_URL + 'reports/fee_and_charges_report/',
    excess_payment_report: BASE_URL + 'reports/excess_payment_report/',
    bpi_and_pf_report: BASE_URL + 'reports/bpi_and_pf_report/',
    demand_and_settlement_report: BASE_URL + 'reports/demand_and_settlement_report/',
    repayment_breakup_report: BASE_URL + 'reports/repayment_breakup_report/',
    repayment_breakup_report_scf: BASE_URL + 'reports/repayment_breakup_report_scf/',

    dashboard_summary: BASE_URL + 'dashboard/summary/',
    dashboard_repayments: BASE_URL + 'dashboard/repayments/',
    dashboard_disbursements: BASE_URL + 'dashboard/disbursements/',

    settle_to_a_loan: BASE_URL + 'records/:id/adjustments/',
    cashback_download_excel: BASE_URL + 'loans/export/',
};
